import { fillLookupValuesByPropertyNames } from "@modernary/mui/components/lookup";
import type { ReportSchedule, ReportScheduleNew } from "./permitVersion";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
  responseAdapter,
};

//TODO:TS
function addAuthRequestFields(entity: ReportSchedule) {
  entity._authRequestFields = ["id", "permitVersionId"] as (keyof ReportSchedule)[];
  return entity;
}
function getInitialData() {
  const result = {} as ReportSchedule;
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: ReportSchedule | ReportScheduleNew }) {
  addAuthRequestFields(response.data as ReportSchedule);
  return response.data;
}
/** Be sure to await this when using it. */
async function responseAdapter(response: { data: ReportSchedule | ReportScheduleNew }) {
  await skinnyResponseAdapter(response);
  await fillLookupValuesByPropertyNames(response.data, ["reportTypeMurn", "frequencyMurn"]);
  return response.data;
}
function requestAdapter(data: any) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: any) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {}
